import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAngleUp,
    faArrowLeft,
    faArrowUpRightFromSquare,
    faXmark,
    faRefresh,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";

import "./styles.scss";

import SOTable from "./SOTable";
import InTable from "./InTable";
import OutTable from "./OutTable";
import QCTable from "./QCTable";
import COMTable from "./ComTable";
import RevData from "./DnDTables/RevTable";
import ComTextarea from "./DnDTables/ComTextarea";
import UserList from "./DnDTables/UserList";

import ModalPortal from "util/component/Modal";
import { Modal, Rev, RevLog } from "util/component/Modal/Modal";
import SearchableSelect from "util/component/SearchableSelect";

import update from "immutability-helper";
import axios from 'util/axios';

import { useTranslation } from "react-i18next";
import Draggable from "react-draggable";
import Editor from "./Editor";
import { initialData_in as initialData } from "./TableDataSet";

const FirstSOParam = { label: "ALL", code: null, desc: "ALL" };

const getAxios = async ({ postData, master_t, sub_t, in_t, out_t, com_t, qc_t, revInfo }) => {
    const res = await axios
        .post(process.env.REACT_APP_API + "/pcsCreate/retrieveSheetMaster", postData)
        .then((Response) => {
            return Response.data.data.result;
        })
        .catch((e) => console.error(e));
    if (!!!res || res.master === null) {
        alert("Error");
        window.history.go(-1);
        return;
    }
    let m = { ...res.master };
    let s = [FirstSOParam];
    // Step Operation
    res.sub.forEach((v, i) => {
        s = [
            ...s,
            {
                ...v,
                code: v.soCode,
                label: v.soNm,
                desc: v.description,
                repeat: v.repeat,
                // soSeq: v.soSeq,
            },
        ];
    });

    master_t((v) => ({ ...v, ...m }));
    sub_t(s);
    in_t({ data: res["in"], header: res?.["header"] });
    out_t({ data: res["out"], header: res?.["header"] });
    qc_t({ data: res["qc"], header: res?.["header"] });
    com_t(res["composition"]);
    revInfo(res.revision.maxRevision);
};

const Preview = () => {
    const { t } = useTranslation(["page"]);

    const dispatch = useDispatch();

    const [SOParams, SetSOParam] = useState([FirstSOParam]);
    const [SelectedSO, SetSelectedSO] = useState(0);
    const tdSelector = useSelector((store) => store.tdSelector);

    const [RevItem, SetRevItem] = useState(0);
    const [RevList, SetRevList] = useState([]);
    const [RevCmptCheckList, SetRevCmptCheckList] = useState([]);

    const [tempData, setTempData] = useState([]);

    const [ModalOpen, SetModalOpen] = useState(false);
    const [revModeCheck, setRevModeCheck] = useState(false);

    const [sheetHeader, setSheetHeader] = useState();
    const [Review, SetReview] = useState(false);

    const [ModalMsg, SetModalMsg] = useState(<p></p>);
    const [RevOpen, SetRevOpen] = useState(false);
    const [RevLogOpen, SetRevLogOpen] = useState(false);

    const [menuOpenS, menuOpen] = useState(true);

    const [Hide, SetHide] = useState(false);

    const userSelector = useSelector((store) => store.user);

    const quillRef = useRef();

    const [inputs, setInputs] = useState({
        plant: "",
        sheetCode: "",
        projectNm: "",
        processCd: "",
        unitCd: "",
        description: "",
        cycle: "1",
    });

    const [revInputs, setRevInputs] = useState({
        sheetCode: "",
        revision: "",
        uniqueCode: "",
        celNm: "",
        userId: "",
        sheetOwner: "",
        revContent: "",
        revLevel: "",
        tempYn: "",
        sheetType: "",
    });
    const [revUserList, setRevUserList] = useState([]);
    const [soSelected, setSoSelected] = useState({
        name: "",
        index: "",
    });
    const [mSelected, setMSelected] = useState({
        description: false,
        descType: "",
        cycle: false,
        cycleType: "",
    });
    const FileInput = useRef();
    const ScrollRef = useRef();

    const autoResizeTextarea = (e) => {
        let textarea = !!e.target ? e.target : e;
        if (textarea) {
            textarea.style.height = "12px";
            let height = textarea.scrollHeight; // 높이
            if (height < 12) {
                height = 12;
            }
            textarea.style.height = `${height}px`;
        }
    };

    const handleModalOpen = (type) => {
        if (type === "temp") SetModalMsg(<p>{t("saved")}</p>);
        else SetModalMsg("");
        SetModalOpen(!ModalOpen);
    };

    const selectDataHandle = (tData, cellData, subIndex, rowIndex, tmpData) => {
        //subIndex == 1
        let newVal = [];

        let tmparr;

        tData.map((v, i) => {
            tmparr = [];
            v.map((vv, ii) => {
                let tmp = [];
                vv.map((vvv) => {
                    let rowDatas;
                    if (
                        vvv.name === cellData.name &&
                        vvv.value === cellData.value &&
                        subIndex - 1 === i &&
                        rowIndex === ii
                    ) {
                        if (cellData.name === "paraCd") {
                            rowDatas = { ...vvv, active: false };
                        } else {
                            rowDatas = { ...vvv, active: true };
                        }
                    } else {
                        rowDatas = { ...vvv, active: false };
                    }
                    tmp = [...tmp, ...[rowDatas]];
                });
                tmparr = [...tmparr, ...[tmp]];
            });
            newVal = [...newVal, [...tmparr]];
        });

        return newVal;
    };
    const selectDataHandle2 = (tData, cellData, subIndex, rowIndex, tmpData) => {
        //subIndex == 1
        let newVal = [];

        let tmparr = [];

        tData.map((v, i) => {
            let tmp = [];
            v.map((vv, ii) => {
                let rowDatas;
                if (
                    vv.name === cellData.name &&
                    vv.value === cellData.value &&
                    subIndex === i &&
                    rowIndex === i
                ) {
                    if (cellData.name === "paraCd") {
                        rowDatas = { ...vv, active: false };
                    } else {
                        rowDatas = { ...vv, active: true };
                    }
                } else {
                    rowDatas = { ...vv, active: false };
                }
                tmp = [...tmp, ...[rowDatas]];
            });
            tmparr = [...tmparr, ...[tmp]];
        });

        return tmparr;
    };
    const handleReviewOpen = (cellData, uniqueCode, tData, type) => {
        const search = new URLSearchParams(window.location.search);
        mid.current = search.get("mid");
        rev.current = search.get("rev");
        tmp.current = !!search.get("tempYn") ? search.get("tempYn") : "N";

        let newVal;
        /*        if(type === 'IN' || type === 'OUT' || type === 'QC'){
            // newVal = selectDataHandle(tData,cellData,subIndex,rowIndex);
            setTempData(newVal);
        }else if(tempData.length > 0 && sheetType !== 'C'){
            // newVal =  selectDataHandle(tempData,cellData,subIndex,rowIndex);
            setTempData(newVal);
        }else if(sheetType === 'C'){
            // newVal =  selectDataHandle2(tData,cellData,subIndex,rowIndex);
            setTempData(newVal);
        }else if(tempData.length > 0 && sheetType === 'C'){
            // newVal =  selectDataHandle2(tempData,cellData,subIndex,rowIndex);
            setTempData(newVal);
        }*/

        setRevInputs({
            sheetCode: mid.current,
            revision: rev.current,
            uniqueCode: uniqueCode,
            celNm: cellData.name,
            userId: userSelector.userId,
            tempYn: tmp.current,
            sheetType: type,
            sheetOwner: inputs.userId,
        });

        if (cellData.name !== "paraCd") {
            SetReview(true);
        } else {
            SetReview(false);
            /*            if(sheetType === 'I' ){
                in_tbl.current.preOnData({data:newVal});
            }*/
            //|| sheetType === 'O' || sheetType === 'Q' || sheetType === 'C'
        }
    };
    const handleClickSQTable = (col, index) => {
        setSoSelected({ name: col, index: index });
    };

    const isUpdate2 = useRef(false);
    const mid = useRef(null);
    const rev = useRef(null);
    const tmp = useRef("N");
    const isAdmin = useRef(false);
    useEffect(() => {
        isAdmin.current = userSelector.isAdmin
        dispatch({ type: "LOADING_ON" });
        const search = new URLSearchParams(window.location.search);
        mid.current = search.get("mid");
        rev.current = search.get("rev");
        tmp.current = !!search.get("tempYn") ? search.get("tempYn") : "N";
        isUpdate2.current = true;
        try {
            getAxios({
                postData: {
                    sheetcd: mid.current,
                    revision: rev.current,
                    tempYn: tmp.current,
                },
                master_t: setInputs,
                sub_t: initialSO,
                in_t: in_tbl.current.loadData,
                out_t: out_tbl.current.loadData,
                qc_t: qc_tbl.current.loadData,
                com_t: com_tbl.current.loadData,
                revInfo: RevInfo,
            });
            getRevCmptCheckList({
                sheetcd: mid.current,
                revision: rev.current,
                tempYn: tmp.current,
            });
            selectSheetHeader({ sheetcd: mid.current, revision: rev.current, tempYn: tmp.current });
            getUserList({sheetCode: mid.current});
        } catch (e) {}
        dispatch({ type: "LOADING_OFF" });
    }, []);

    const getUserList = useCallback(
        async (data) => {
            const response = await axios.post(
                process.env.REACT_APP_API + "/pcsReview/retrieveCallUserList",
                data
            );

            const resultData = response.data.data.result;
            setRevUserList(resultData);
        },
        [revUserList]
    );

    const getRevCmptCheckList = useCallback(
        async (data) => {
            const TRIANGLE_RED = "#F84F31";
            const TRIANGLE_GREEN = "#23c552";

            const response = await axios.post(
                process.env.REACT_APP_API + "/pcsReview/findRevCmptCheck",
                data
            );
            if (response.status === 200) {
                const resultData = response.data.data.result;
                SetRevCmptCheckList(resultData);

                const sheetReview =
                    resultData !== undefined
                        ? resultData.filter((sheet) => sheet.uniqueCode === "M")
                        : undefined;
                const sheetData1 =
                    sheetReview !== undefined
                        ? sheetReview.findIndex((key) => key.celNm === "description")
                        : undefined;
                const sheetData2 =
                    sheetReview !== undefined
                        ? sheetReview.findIndex((key) => key.celNm === "cycle")
                        : undefined;
                let cycle;
                let description;
                let cycleType;
                let descType;

                if (
                    sheetData2 !== undefined &&
                    sheetReview[sheetData2] !== undefined &&
                    sheetData2 > -1
                ) {
                    cycle = true;
                    cycleType =
                        sheetReview[sheetData2].cmptType === "R" ? TRIANGLE_RED : TRIANGLE_GREEN;
                } else {
                    cycle = false;
                }
                if (
                    sheetData1 !== undefined &&
                    sheetReview[sheetData1] !== undefined &&
                    sheetData1 > -1
                ) {
                    description = true;
                    descType =
                        sheetReview[sheetData1].cmptType === "R" ? TRIANGLE_RED : TRIANGLE_GREEN;
                } else {
                    description = false;
                }
                setMSelected({
                    cycle: cycle,
                    cycleType: cycleType,
                    description: description,
                    descType: descType,
                });
            } else {
                throw new Error("getAxios");
            }
        },
        [RevCmptCheckList]
    );

    const selectSheetHeader = useCallback(
        async (data) => {
            const response = await axios.post(
                process.env.REACT_APP_API + "/pcsReview/selectSheetHeader",
                data
            );
            if (response.status === 200) {
                const resultData = response.data.data.result;
                setSheetHeader(resultData);
            } else {
                throw new Error("getAxios");
            }
        },
        [revInputs]
    );

    const soRef = useRef(null);
    const initialSO = (d) => {
        soRef.current.setData(
            update(d, {
                $splice: [[0, 1]],
            })
        );
    };

    useEffect(() => {
        if (!isUpdate2.current) {
            SetSOParam([FirstSOParam]);
        }
        SetSelectedSO(0);
    }, [inputs.unitCd]);

    const changeSO = (data) => {
        SetSOParam([FirstSOParam, ...data]);
    };

    const OnClickSO = (index) => {
        SetSelectedSO(index);
    };

    const ScrollMove = (direction) => {
        let move = 450;
        if (direction === "left") {
            move = move * -1;
        }
        ScrollRef.current.scrollLeft += move;
    };

    const RevInfo = (maxRevision) => {
        let revList = [];
        for (let i = 1; i <= maxRevision; i++) {
            revList = [...revList, { value: i, label: i }];
        }
        SetRevList(revList);
        SetRevItem(rev.current);
    };

    const in_tbl = useRef(null);
    const out_tbl = useRef(null);
    const qc_tbl = useRef(null);
    const com_tbl = useRef(null);

    const renderRevLog = useMemo(() => {
        if (!RevLogOpen) return null;
        else
            return (
                <ModalPortal>
                    <RevLog
                        onClose={() => SetRevLogOpen(false)}
                        data={{
                            sheetcd: inputs.sheetCode,
                            revision: parseInt(RevItem),
                        }}
                    ></RevLog>
                </ModalPortal>
            );
    }, [RevLogOpen, RevItem, inputs]);

    const renderRev = useMemo(() => {
        if (!RevOpen) return null;
        else
            return (
                <ModalPortal>
                    <Rev onClose={() => SetRevOpen(false)} data={inputs.sheetCode}></Rev>
                </ModalPortal>
            );
    }, [RevOpen]);

    return (
        <div className="bpl-container">
            <section className="preview">
                <div className="info_top">
                    <table id="head-table">
                        <thead>
                            <tr>
                                <th>Plant</th>
                                <th>Project</th>
                                <th>MBR No</th>
                                <th>Process</th>
                                <th>Unit Operation</th>
                                <th>Description</th>
                                <th>Cycle</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{inputs?.plant}</td>
                                <td>{inputs?.projectNm}</td>
                                <td>{inputs?.mbrNo}</td>
                                <td>{inputs?.processCd}</td>
                                <td>{inputs?.unitNm}</td>
                                <td
                                    onClick={() => {
                                        // handleReviewOpen({name:'description'},"M","",'M');
                                        // handleClickSQTable("m_description",0);
                                    }}
                                    style={{
                                        overflow: "hidden",
                                        position: "relative",
                                        background:
                                            soSelected.name === "m_description" &&
                                            soSelected.index === 0
                                                ? "#eee"
                                                : "transparent",
                                    }}
                                >
                                    {/* {mSelected.description ? <div style={{position: "absolute", backgroundColor: mSelected.descType, top: 0, right: 0, width: 15, height: 15, transform: "translateX(7px) translateY(-7px) rotateZ(45deg)"}}></div> : ""} */}
                                    <span>{inputs?.description}</span>
                                </td>
                                <td
                                    style={{
                                        overflow: "hidden",
                                        position: "relative",
                                        textAlign: "right",
                                        background:
                                            soSelected.name === "m_cycle" && soSelected.index === 0
                                                ? "#eee"
                                                : "transparent",
                                    }}
                                    onClick={() => {
                                        // handleReviewOpen({name:'cycle'},"M","",'M');
                                        // handleClickSQTable("m_cycle",0);
                                    }}
                                >
                                    {/* {mSelected.cycle ? <div style={{position: "absolute", backgroundColor: mSelected.cycleType, top: 0, right: 0, width: 15, height: 15, transform: "translateX(7px) translateY(-7px) rotateZ(45deg)"}}></div> : ""} */}
                                    <span>{inputs?.cycle}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={"info_middle cf " + (Hide ? "hide" : "")}>
                    <h1 className={"title "} onClick={() => SetHide(!Hide)}>
                        <FontAwesomeIcon icon={faAngleUp} />
                    </h1>
                    <div className={"so-section "}>
                        <div className="left">
                            <SOTable
                                ref={soRef}
                                onChg={changeSO}
                                cycle={inputs?.cycle}
                                onOpen={handleReviewOpen}
                                soSelected={soSelected}
                                setSoSelected={setSoSelected}
                                handleClickSQTable={handleClickSQTable}
                                RevCmptCheckList={RevCmptCheckList}
                            />
                        </div>

                        <div className="right">
                            <div className="revision">
                                <div className="re_top">
                                    <h4>Revision</h4>
                                    {RevList.length > 0 && (
                                        <div className="re_btn" onClick={() => SetRevOpen(true)}>
                                            Rev.History
                                        </div>
                                    )}
                                </div>

                                <div className="re_bottom">
                                    {RevList.length > 0 ? (
                                        <>
                                            <div className="re_left">
                                                <SearchableSelect
                                                    name="rev_history"
                                                    search={false}
                                                    options={RevList}
                                                    value={RevItem}
                                                    textAlign={"center"}
                                                    arrow={true}
                                                    onChange={(v) => {
                                                        SetRevItem(v.value);
                                                    }}
                                                />
                                            </div>
                                            <div className="re_right">
                                                <div
                                                    onClick={() => SetRevLogOpen(true)}
                                                    className="log_btn"
                                                >
                                                    LOG
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <p style={{ textAlign: "center" }}>{t("noRevision")}</p>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="info_bottom">
                    <div className="left">
                        <ul className="arrow">
                            <li onClick={() => ScrollMove("left")}>{"<"}</li>
                        </ul>
                        <ul className="tap" ref={ScrollRef}>
                            {SOParams.map((v, i) => {
                                return (
                                    <li
                                        key={i}
                                        className={SelectedSO === i ? "on" : ""}
                                        onClick={() => OnClickSO(i)}
                                    >
                                        {v.desc}
                                    </li>
                                );
                            })}
                        </ul>
                        <ul className="arrow">
                            <li onClick={() => ScrollMove("right")}>{">"}</li>
                        </ul>
                    </div>

                    {/* <div className={"right " + (menuOpenS ? "active" : "")}>
                        <div className="action_btn">
                            <div className="ab_relative">
                                <div className="contain" onClick={() => menuOpen(!menuOpenS)}>
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                </div>
                            </div>
                            <div className="actions">
                                <ul className="work_btn">
                                    <li className="s_btn" style={{backgroundColor:"#6300ff",color: "#FFF"}} onClick={goDetail}>
                                        Review Complete
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div> */}
                </div>
                <div className="d-none">
                    <input type="file" ref={FileInput} />
                </div>
            </section>
            <Editor ref={quillRef} webContent={inputs.webContent} />
            <COMTable
                ref={com_tbl}
                RevCmptCheckList={RevCmptCheckList}
                onOpen={handleReviewOpen}
                unitCd={inputs.unitCd}
                PData={null}
                autoResizeTextarea={autoResizeTextarea}
            />
            <InTable
                ref={in_tbl}
                RevCmptCheckList={RevCmptCheckList}
                so={SOParams}
                sso={SelectedSO}
                PData={null}
                autoResizeTextarea={autoResizeTextarea}
                onOpen={handleReviewOpen}
            />
            <OutTable
                ref={out_tbl}
                RevCmptCheckList={RevCmptCheckList}
                so={SOParams}
                sso={SelectedSO}
                PData={null}
                PROCode={inputs.processCd}
                autoResizeTextarea={autoResizeTextarea}
                onOpen={handleReviewOpen}
            />
            <QCTable
                ref={qc_tbl}
                RevCmptCheckList={RevCmptCheckList}
                so={SOParams}
                sso={SelectedSO}
                PData={null}
                PROCode={inputs.processCd}
                autoResizeTextarea={autoResizeTextarea}
                onOpen={handleReviewOpen}
            />

            {ModalOpen && (
                <ModalPortal>
                    <Modal onClose={handleModalOpen}>{ModalMsg}</Modal>
                </ModalPortal>
            )}
            {renderRev}
            {renderRevLog}
            {Review && (
                <ReviewDiv
                    tdSelector={tdSelector}
                    onClose={() => SetReview(false)}
                    revInputs={revInputs}
                    setRevInputs={setRevInputs}
                    tempData={tempData}
                    in_tbl={in_tbl}
                    out_tbl={out_tbl}
                    qc_tbl={qc_tbl}
                    com_tbl={com_tbl}
                    setSoSelected={setSoSelected}
                    getRevCmptCheckList={getRevCmptCheckList}
                    setRevModeCheck={setRevModeCheck}
                    sheetHeader={sheetHeader}
                    revUserList={revUserList}
                />
            )}
            {revModeCheck && (
                <ModalPortal>
                    <Modal onClose={() => setRevModeCheck(false)}>
                        {" "}
                        리뷰 작성이 불가능한 시트입니다.
                    </Modal>
                </ModalPortal>
            )}
        </div>
    );
};

const ReviewDiv = ({
    tdSelector,
    onClose,
    revInputs,
    setRevInputs,
    tempData,
    in_tbl,
    out_tbl,
    qc_tbl,
    com_tbl,
    setSoSelected,
    getRevCmptCheckList,
    setRevModeCheck,
    sheetHeader,
    revUserList,
}) => {
    const [visible, setVisible] = useState(true);
    const canMove = useRef(true);

    const [reviewList, setReviewList] = useState({ info: {}, list: [] });

    const [userState, setUserState] = useState(false);
    const [userList, setUserList] = useState({ label: "", value: "" });
    const [textAreHtml, setTextAreHtml] = useState({
        revContent: "",
    });
    const [textAreText, setTextAreText] = useState({
        revContent: "",
    });

    const [ReviewInfo, SetReviewInfo] = useState(null);

    const textRef = useRef(null);

    /*    out_tbl
    qc_tbl
    com_tbl*/

    const handleVisible = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setVisible(!visible);
    };

    const getReviewList = useCallback(async () => {
        let response;
        try {
            response = await axios.post(process.env.REACT_APP_API + "/pcsReview/list", revInputs);
            const resultData = response.data.data.result;
            const reviewInfo = await axios.post(
                process.env.REACT_APP_API + "/pcsReview/retrieveSheetReviewing",
                revInputs
            ).then(Response => Response.data.data.result)

            setReviewList({ info: reviewInfo, list: resultData });
        } catch (e) {
            console.error(e, response);
        }
    }, [revInputs]);

    useEffect(() => {
        getReviewList()
    }, [getReviewList]);

    const getSheetOnly = useCallback(async () => {
        let url = "/pcsCreate/retrieveSheetInOnly";

        if (revInputs.sheetType === "IN") {
            url = "/pcsCreate/retrieveSheetInOnly";
        } else if (revInputs.sheetType === "OUT") {
            url = "/pcsCreate/retrieveSheetOutOnly";
        } else if (revInputs.sheetType === "QC") {
            url = "/pcsCreate/retrieveSheetQcOnly";
        } else if (revInputs.sheetType === "COM") {
            url = "/pcsCreate/retrieveSheetCompositionOnly";
        }

        const response = await axios.post(process.env.REACT_APP_API + url, {
            sheetcd: revInputs.sheetCode,
            revision: revInputs.revision,
            tempYn: revInputs.tempYn,
        });
        if (response.status === 200) {
            const resultData = response.data.data.result;
            if (revInputs.sheetType === "IN") {
                in_tbl.current.loadData({ data: resultData, header: sheetHeader });
            } else if (revInputs.sheetType === "OUT") {
                out_tbl.current.loadData({ data: resultData, header: sheetHeader });
            } else if (revInputs.sheetType === "QC") {
                qc_tbl.current.loadData({ data: resultData, header: sheetHeader });
            } else if (revInputs.sheetType === "COM") {
                com_tbl.current.loadData({ data: resultData, header: sheetHeader });
            }
        } else {
            throw new Error("getAxios");
        }
    }, [revInputs]);

    const revSave = () => {
        const payload = {
            ...revInputs,
            revContent: textRef.current.innerHTML,
            revLevel: 1,
        };
        axios
            .post(process.env.REACT_APP_API + "/pcsReview/saveRev", payload)
            .then((Response) => {
                if (Response.data.code === 403) {
                    setRevModeCheck(true);
                } else {
                    getReviewList()
                    textRef.current.innerHTML = "";
                    const reLoadData = {
                        ...revInputs,
                        revContent: "",
                        revLevel: 1,
                    };
                    setUserState(false);
                    // setRevInputs(reLoadData);
                    getRevCmptCheckList({
                        sheetcd: revInputs.sheetCode,
                        revision: revInputs.revision,
                        tempYn: revInputs.tempYn,
                    });

                    getSheetOnly()

                    clearTextarea();
                }
            })
            .catch((e) => console.error(e));
    };

    const replySave = (replyInputs, setReplyInputs) => {
        const res = axios
            .post(process.env.REACT_APP_API + "/pcsReview/saveReply", replyInputs)
            .then((Response) => {
                getReviewList()

                const payload = {
                    ...replyInputs,
                    revContent: "",
                };
                setReplyInputs(payload);

                return Response.data.data.result;
            })
            .catch((e) => console.error(e));
    };
    const cmptTypeUpdate = (cmptType, revNo) => {
        const payload = {
            ...revInputs,
            revNo: revNo,
            cmptType: cmptType,
        };

        const res = axios
            .post(process.env.REACT_APP_API + "/pcsReview/modifyCmptType", payload)
            .then((Response) => {
                getReviewList()
                getRevCmptCheckList({
                    sheetcd: revInputs.sheetCode,
                    revision: revInputs.revision,
                    tempYn: revInputs.tempYn,
                });
                getSheetOnly()
            })
            .catch((e) => console.error(e));
    };
    const onChangetextareaHandler = (e, value) => {
        const payload = {
            ...revInputs,
            revContent: value,
            revLevel: 1,
        };

        setRevInputs(payload);
    };

    const saved = useRef();
    const MO = (e) => {
        if (!!tdSelector.td) {
            saved.current = tdSelector.td;
        }
        if (e.type === "mousedown") {
        }
        canMove.current = false;
    };

    const revShowHide = (e) => {
        com_tbl.current.resetData();
        in_tbl.current.resetData();
        out_tbl.current.resetData();
        qc_tbl.current.resetData();
        setSoSelected({ name: "", index: "" });

        onClose();
    };

    const ML = () => {
        canMove.current = true;
    };

    const clearTextarea = () => {
        revInputs.revContent = "";
    };
    const textOnview = (e) => {
        const textData = e.target.innerText;

        let user = revUserList.filter(
            (data) =>
                data.label
                    .toLowerCase()
                    .indexOf(
                        textData
                            .toLowerCase()
                            .substring(textData.lastIndexOf("@") + 1, textData.length)
                    ) !== -1
        );
        if (
            user.length !== 0 &&
            textData !== "" &&
            textData.substring(textData.lastIndexOf("@"), textData.lastIndexOf("@") + 1) === "@"
        ) {
            setUserState(true);
        } else {
            setUserState(false);
        }
        setUserList(user);
    };
    const userClick = (data) => {
        const revContentHtml = textRef.current.innerHTML;
        const revContentText = textRef.current.innerText;
        const textData = revContentHtml?.substring(revContentHtml.lastIndexOf("@"), -1);

        const payloadHtml = {
            revContent:
                textData +
                '<span suppressContentEditableWarning={true} contentEditable="false" class="bpl-reviewerspan" data-userId='+data.value+'>' +
                "@" +
                data.label +
                "</span>",
        };
        setUserState(false);
        setTextAreHtml(payloadHtml);
    };

    // onMouseOver={MO} onMouseLeave={ML} onMouseDown={MO} 지우기
    return (
        <section className="preview">
            <Draggable
                onStart={() => {
                    return canMove.current;
                }}
            >
                <div className="prebox">
                    <div className="preTop" style={{ cursor: "all-scroll" }}>
                        <div className="close" onClick={(e) => revShowHide(e)}>
                            <div className="cc c1"></div>
                            <div className="cc c2"></div>
                        </div>
                    </div>
                    <div className="middle">
                        {reviewList.list?.map((data, i) => (
                            <RevData
                                key={`RevData-data-${i}`}
                                data={data}
                                replySave={replySave}
                                cmptTypeUpdate={cmptTypeUpdate}
                                revInputs={revInputs}
                                revUserList={revUserList}
                            />
                        ))}
                    </div>

                    <div className="bottom">
                        {reviewList.info.assignYn === "Y" &&
                        reviewList.info.reviewEnd !== "Y" &&
                        reviewList.info.reviewing === "I" ? (
                            <>
                                <div
                                    style={{
                                        position: "relative",
                                        flex: 3,
                                        height: "100%",
                                        marginRight: 15,
                                    }}
                                >
                                    <div className="box_txa" style={{ padding: 5 }}>
                                        <ComTextarea
                                            ref={textRef}
                                            onview={textOnview}
                                            revInputs={revInputs}
                                            onChangetextareaHandler={onChangetextareaHandler}
                                            textAreHtml={textAreHtml}
                                        />
                                    </div>
                                    {userState && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "auto",
                                                left: 0,
                                                right: 0,
                                                bottom: "100%",
                                                height: 200,
                                                border: "1px solid #aaa",
                                                background: "white",
                                            }}
                                        >
                                            <UserList user={userList} userClick={userClick} />
                                        </div>
                                    )}
                                </div>

                                <div className="btn_box" style={{ flex: 1 }}>
                                    <button className="btn" onClick={revSave}>
                                        저장
                                    </button>
                                </div>
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
            </Draggable>
        </section>
    );
};
export default Preview;
